export function encodeNumberArrayToBase64(numbers: number[]): string {
  const buffer = new ArrayBuffer(numbers.length * 2);

  const view = new Uint16Array(buffer);

  view.set(numbers);

  const binaryString = String.fromCharCode.apply(
    null,
    Array.from(new Uint8Array(buffer)),
  );

  const base64: string = btoa(binaryString);

  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

export function decodeBase64ToNumberArray(
  urlSafeBase64: string | null,
): number[] {
  if (!urlSafeBase64) {
    return [];
  }
  let base64 = urlSafeBase64.replace(/-/g, "+").replace(/_/g, "/");

  while (base64.length % 4) {
    base64 += "=";
  }

  const binaryString = atob(base64);

  const buffer = new ArrayBuffer(binaryString.length);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < binaryString.length; i++) {
    view[i] = binaryString.charCodeAt(i);
  }

  return Array.from(new Uint16Array(buffer));
}
